export default __webpack_public_path__ + "static/media/key.23853599.svg";